﻿const _url = '/ppapi/ProductMetric';
export default (function () {
    class Metric {
        constructor({ id, name, isDefault, orderNumber }) {
            this.id = id;
            this.name = name;
            this.isDefault = isDefault;
            this.orderNumber = orderNumber;
        }

        async get(id) {
            if (typeof id === 'number' && id > 0) {
                this.id = id;
            }

            const response = await fetch(`${_url}/${this.id}`, {
                method: 'GET',
                cache: 'no-cache'
            });

            const result = await response.json();

            if (Object.keys(result).length > 0) {
                if (typeof result.Name !== "undefined") {
                    this.name = result.Name;
                }

                if (typeof result.OrderNumber !== "undefined") {
                    this.orderNumber = result.OrderNumber;
                }

                if (typeof result["Default"] !== "undefined") {
                    this.isDefault = result["Default"];
                }
            }

            return this;
        }
    }

    async function getMetrics(token = undefined) {
        const metrics = [];

        const url = (!!token) ? `${_url}?authToken=${token}` : _url;

        const response = await fetch(`${url}`, {
            method: 'GET',
            cache: 'no-cache'
        });
        const results = await response.json();

        if (results.length > 0) {
            results.forEach(item => {
                metrics.push(new Metric({
                    id: item.ID,
                    name: item.Name,
                    isDefault: item['Default'],
                    orderNumber: item.OrderNumber
                }));
            });
        }

        return metrics;
    }

    return {
        Metric,
        getMetrics
    }
})();